import { createFileRoute } from '@tanstack/react-router'

import {
  forbiddenErrorComponent,
  requireGxpEnabled,
  requirePermission,
} from '@/lib/routeGuards'
import { AuditExportSettings } from '@/pages/Settings/AuditExportSettings'

export const Route = createFileRoute('/_app/settings/audit-exports')({
  component: AuditExportSettings,
  beforeLoad: ({ context }) => {
    requireGxpEnabled(context.pinStatus)
    requirePermission(context.permissions, 'read:audit_export_config')
  },
  errorComponent: forbiddenErrorComponent,
})
